import { render, staticRenderFns } from "./waitTaskList.vue?vue&type=template&id=517bf482&scoped=true&"
import script from "./waitTaskList.vue?vue&type=script&lang=js&"
export * from "./waitTaskList.vue?vue&type=script&lang=js&"
import style0 from "./waitTaskList.vue?vue&type=style&index=0&id=517bf482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517bf482",
  null
  
)

export default component.exports